import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

library.add(fas) // Include needed solid icons
library.add(far) // Include needed regular icons

export default defineNuxtPlugin((app) => {
  app.vueApp.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
});
export {aliases, fa} from 'vuetify/iconsets/fa-svg';